// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import { FixedSizeList } from 'react-window';

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import {
    Checkbox, createFilterOptions,
    FormHelperText,
    Input,
    InputLabel,
    Select, Stack, TextField,
    Tooltip
} from "@mui/material";

// App Imports
import {addContractDataPoint, editContractDataPoint} from "./ContractDataPointClient";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import {changeContractDataPoint} from "./contractDataPointSlice";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import {getAllDataPointValues} from "../DataPointValue/DataPointValueClient";
import {getAllDataPoints} from "../DataPoint/DataPointClient";
import {Autocomplete} from "@mui/lab";




// Main Function
export default function ContractDataPointDrawer({contractDataPointDrawerState,contractDataPointDrawerMode}) {


    // ****************** BEGIN STATES ****************************

    const [submitting, setSubmitting] = useState(true);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************
    const dispatchData = useDispatch();
    const selectorContractDataPointId = useSelector((state) => state.contractDataPointSlc.value.id);
    const selectorDataPointId = useSelector((state) => state.contractDataPointSlc.value.dataPointId);
    const selectorCdpDrawerState = useSelector((state) => state.contractDataPointSlc.value.cdpDrawerState);
    const selectorCdpDrawerMode = useSelector((state) => state.contractDataPointSlc.value.cdpDrawerMode);
    const[versionFlag, setVersionFlag] = useState(useSelector((state) => state.contractDataPointSlc.value.versionInd));
    const[cycleFlag, setCycleFlag] = useState(useSelector((state) => state.contractDataPointSlc.value.cycleInd));
    const selectorContractGridAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);

    // ****************** END STORE ****************************



    // ****************** BEGIN REGISTER ****************************

    // const {register, handleSubmit} = useForm();
    const { register, handleSubmit,setValue,  control, formState: { errors } } = useForm();
    // ****************** END REGISTER ****************************

    const filter = createFilterOptions({
        stringify: (option) => option.name || ""
    });


    // ****************** BEGIN CRUD ****************************

    function onSubmit(data) {
        setSubmitting(true)
        console.log("here's my contractDataPoint data")
        console.log({data})
        console.log("here's my stringify data")
        console.log(JSON.stringify(data, null, 2))
        if(selectorCdpDrawerMode==="Add"){
            addContractDataPoint(data)
                .then(() => {
                    console.log("ContractDataPoint added");
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record added"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Add failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeContractDataPoint({
                    id: 0,
                    contractSectionId: null,
                    ordinalNumber: null, dataPointId: null,
                    contractLevel: null, destinationFolder: null, versionInd: false, versionNumber: null, cycleInd: false, cycleNumber: null,
                    sourceContractSectionId: null, sourceContractDataPointId: null,
                    status: null,
                    mockIndicator: null, mockValue: null, mockOrigin: null, mockExpression: null, mockExpressionTranslation: null,
                    createdOn: null,createdBy: null,lastModifiedOn: null,lastModifiedBy: null,
                    cdpDrawerState: false, cdpGridRefresh: true}));
            })}
        if(selectorCdpDrawerMode==="Edit"){
            console.log("This is the contractDataPoint Id I am going to edit")
            console.log(selectorContractDataPointId)

            editContractDataPoint(selectorContractDataPointId, data)
                .then(() => {
                    console.log("ContractDataPoint edited")
                    dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record edited"}));
                }).catch(err => {
                console.log(err)
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "error", crudMessage: "Edit failed"}));
            }).finally(() =>{
                setSubmitting(false);
                dispatchData(changeContractDataPoint({cdpDrawerState: false, cdpGridRefresh: true}));
            })}
    };




    // ****************** END CRUD ****************************

    // ****************** BEGIN MISC ****************************

    const onFinishFailed = errorInfo => {
        alert(JSON.stringify(errorInfo, null, 2));
    };

    function closeContractDataPointDrawer() {
        dispatchData(changeContractDataPoint({cdpDrawerState: false }));
    };

    function prependContractLevel(data3) {
        data3.unshift({
            dataPointId:null,
            dataPointMcode:"",
            dataPointName:"",
            dataType:"",
            description:"",
            exceptionInd:false,
            id:null,
            idString:"",
            mcode:"",
            name:"",
            ordinalNumber:null,
            status:""
        });


    };


    // ****************** END MISC ****************************

    function ListboxComponent(props) {
        const { children, ...other } = props;

        return (
            <FixedSizeList
                height={300}
                // width="100%"
                width={600}
                itemSize={28}
                itemCount={children.length}
                {...other}
            >
                {({ index, style }) => React.cloneElement(children[index], { style })}
            </FixedSizeList>
        );
    }


    // *********************** BEGIN DROPDOWNS **************************


    const [levelDropdown, setLevelDropdown] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState(null);

    const [FolderDropdown, setFolderDropdown] = useState([]);
    const [selectedFolder, setSelectedFolder] = useState(null);



    const fetchDataPointValuesForDropdowns = () =>
        getAllDataPointValues()

            .then(data => {
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                setFolderDropdown(data.filter(data => data.dataPointId ===  2199));
                let data2 = data;
                let data3 = data2.filter(data2 => data2.dataPointId ===  96);
                console.log("Contract Levels");
                console.log(data3);
                prependContractLevel(data3);
                console.log("prepended data");
                console.log(data3);
                setLevelDropdown(data3);

            })
    useEffect(() => {
        console.log("This is for the dropdown2...");
        fetchDataPointValuesForDropdowns();
    }, []);

    const renderDataPoints2 = dataPointValues => {
        if (dataPointValues.length <= 0) {
            return "No Data";
        }}


    const handleLevelChange = (levelEvent) => {
        setSelectedLevel(levelEvent.target.value);
        dispatchData(changeContractDataPoint({contractLevel: levelEvent.target.value}));
        console.log("This is for the selected Value");
        console.log(levelEvent.target.value);
    };

    const handleFolderChange = (folderEvent) => {
        setSelectedFolder(folderEvent.target.value);
        dispatchData(changeContractDataPoint({destinationFolder: folderEvent.target.value}));
        console.log("This is for the selected Origin");
        console.log(folderEvent.target.value);
    };


// *********************** END DROPDOWNS **************************

    // ******************* BEGIN AUTOCOMPLETE *********************

    const [dataPointDropdown, setDataPointDropdown] = useState([]);
    const [dataPoints, setDataPoints] = useState([]);
    const [selectedDataPoint, setSelectedDataPoint] = useState(null);


    const fetchDataPoints = () =>
        getAllDataPoints()

            .then(data => {
                console.log(data);
                setDataPoints(data);
            })
    useEffect(() => {
        fetchDataPoints();
    }, []);

    const handleDataPointChange = (dataPointEvent) => {
        console.log("handleDataPointChange triggered by ", dataPointEvent);
        // setSelectedDataPoint(dataPointEvent);
        dispatchData(changeContractDataPoint({dataPointId: dataPointEvent}));
        console.log("This is for the selected Value");
        console.log(dataPointEvent);
    };

    // this sets the setValue to the dp id that is loaded when editing
    useEffect(() => {
        const existingValue = selectorDataPointId;
        setValue('dataPoint.id', existingValue ? existingValue : null);
    }, [selectorDataPointId, setValue]);

    // ****************** BEGIN FORM ****************************

    function contractDataPointForm(){
        return(
            <form
                onSubmit={handleSubmit((data)=>        onSubmit(data))}
            >
                <Box
                    sx={{width: 800, height: 300, pl: 5}}
                    role="presentation"
                >

                    {selectorContractGridAPI !== "Dashboards" && <h2 style={{
                        paddingLeft: 0,
                        cursor: 'pointer'
                    }} onClick={() => closeContractDataPointDrawer()}>Contract Data Point Form</h2>}
                    {selectorContractGridAPI === "Dashboards" && <h2 style={{
                        paddingLeft: 0,
                        cursor: 'pointer'
                    }} onClick={() => closeContractDataPointDrawer()}>Returned Data Point Form</h2>}
                    <h4>{selectorCdpDrawerMode} Mode</h4>
                    <Input
                        style={{visibility: "hidden"}}
                        {...register('id', {required: true})}
                        id="id" name="id" label="id" aria-describedby="id_entry"
                        defaultValue={Number(useSelector((state) => state.contractDataPointSlc.value.id))}
                    />
                    <Input
                        style={{visibility: "hidden"}}
                        {...register('contractSection.id', {required: true})}
                        id="contractSection.id" name="contractSection.id" label="contractSectionId"
                        aria-describedby="contractSectionId_entry"
                        defaultValue={Number(useSelector((state) => state.contractDataPointSlc.value.contractSectionId))}
                    />
                    <br/>
                    <InputLabel htmlFor="ordinalNumber">Order</InputLabel>
                    <Input
                        {...register('ordinalNumber', {required: false})}
                        id="ordinalNumber" name="ordinalNumber" label="Order" aria-describedby="ordinalNumber_entry"
                        defaultValue={useSelector((state) => state.contractDataPointSlc.value.ordinalNumber)}
                        sx={{width: 100}}/>
                    {/*<FormHelperText id="name_helper">enter the Order</FormHelperText>*/}
                    <br/>
                    <br/>
                    {/*<FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>*/}
                    {/*    <InputLabel htmlFor="dataPoint.id">Data Point</InputLabel>*/}
                    {/*    <Select*/}

                    {/*        {...register('dataPoint.id', { required: true })}*/}
                    {/*        labelId="dataPoint.id"*/}
                    {/*        id="dataPoint.id"*/}
                    {/*        // value={selectedValue}*/}
                    {/*        label="dataPoint.id"*/}
                    {/*        onChange={handleDataPointChange}*/}
                    {/*        defaultValue=        {useSelector((state) => state.contractDataPointSlc.value.dataPointId)}*/}
                    {/*        sx={{ width: 300 }}*/}
                    {/*    >*/}
                    {/*        {dataPoints.map((DataPointItem) =>*/}
                    {/*            <MenuItem value={DataPointItem.id}>{DataPointItem.name}</MenuItem>*/}
                    {/*        )}*/}
                    {/*    </Select>*/}
                    {/*    <FormHelperText id="contractLevel_helper">select the Data Point</FormHelperText>*/}
                    {/*</FormControl>*/}
                    {/*<Autocomplete*/}
                    {/*    disablePortal*/}
                    {/*    id="dataPointId"*/}
                    {/*    options={dataPoints}*/}
                    {/*    getOptionLabel={(option) => option.name}*/}
                    {/*    onChange={(event, newValue) => {*/}
                    {/*        handleDataPointChange(newValue?.id);*/}
                    {/*    }}*/}
                    {/*    sx={{ width: 300 }}*/}
                    {/*    renderInput={(params) => <TextField {...params} label="Data Point" />}*/}
                    {/*    isOptionEqualToValue={(option, value) => option.id === value?.id}*/}
                    {/*    defaultValue={dataPoints.find(dp => dp.id === useSelector((state) => state.contractDataPointSlc.value.dataPointId))}*/}
                    {/*/>*/}
                    <br/>
                    <Autocomplete
                        disablePortal
                        disableCloseOnBlur
                        ListboxProps={{
                            style: {
                                maxHeight: 400,  // <-- make the listbox longer
                            },
                            onClick: (event) => {
                                event.stopPropagation();
                            }
                        }}

                            labelId="dataPoint.id"
                        id="dataPointId"
                        options={dataPoints}
                        // getOptionLabel={(option) => option.name}
                        // getOptionLabel={(option) => option && option.name ? option.name : ""}
                        getOptionLabel={(option) => {
                            if (!option) return "";
                            if (typeof option === 'number' || typeof option === 'string') {
                                const found = dataPoints.find(dp => dp.id === parseInt(option));
                                return found && found.name ? found.name : "";
                            }
                            return option && option.name ? option.name : "";
                        }}
                        // filterOptions={(options, state) => {
                        //     return options.filter(option => {
                        //         const name = option && option.name ? option.name : "";
                        //         return name.toLowerCase().includes(state.inputValue.toLowerCase());
                        //     });
                        // }}
                        filterOptions={filter}
                        isOptionEqualToValue={(option, value) => option && value ? option.id === value.id : option === value}
                        // isOptionEqualToValue={(option, value) => option && value ? option.id === '999999' : option === value}
                        // isOptionEqualToValue={() => false}
                        // isOptionEqualToValue={(option, value) => option.id === value.id}
                        // isOptionEqualToValue={(option, value) =>
                        //     option && value ? option.id === value.id : option === value}
                        // defaultValue=        {useSelector((state) => state.contractDataPointSlc.value.dataPointId)}
                        // value={dataPoints.find(dp => dp.id === parseInt(selectorContractDataPointId))}
                        // value={selectorDataPointId || null}
                        value={dataPoints.find(dp => dp.id === parseInt(selectorDataPointId)) || null}
                        onChange={(event, newValue) => {
                            setSelectedDataPoint(newValue);
                            setValue('dataPoint.id', newValue ? newValue.id : null, { shouldValidate: true });
                            console.log("onChange triggered in Data Point dropddown");
                            handleDataPointChange(newValue ? newValue.id : null);
                        }}
                        onInputChange={(event, newInputValue, reason) => {
                            console.log("onInputChange triggered", newInputValue, reason);
                        }}
                        onHighlightChange={(event, option, reason) => {
                            console.log("onHighlightChange triggered", option, reason);
                        }}
                        sx={{width: 600}}
                        // renderOption={(props, option) => (
                        //     <Tooltip
                        //         title={option.description || ""}
                        //         placement="right"
                        //         enterDelay={500}
                        //     >
                        //         <li {...props}>
                        //             {option.name}
                        //         </li>
                        //     </Tooltip>
                        // )}
                        renderInput={(params) => <TextField {...params} label="Data Point" variant="standard"/>}
                        // ListboxComponent={ListboxComponent}
                    />
                    <FormHelperText id="DataPoint_helper">select the Data Point</FormHelperText>

                    <br/>


                    <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                        <InputLabel htmlFor="contractLevel">Contract Level</InputLabel>
                        <Select

                            {...register('contractLevel', {required: false})}
                            labelId="demo-simple-select-filled-contractLevel"
                            id="contractLevel"
                            FreeSolo={true}
                            // value={selectedValue}
                            label="Contract Level"
                            onChange={

                                handleLevelChange}
                            // defaultValue={useSelector((state) => state.contractDataPointSlc.value.contractLevel)}
                            value={useSelector((state) => state.contractDataPointSlc.value.contractLevel)}
                            sx={{width: 300}}
                        >
                            {levelDropdown.map((LevelItem) => (
                                <MenuItem
                                    key={LevelItem.id}
                                    value={LevelItem.name}
                                >
                                    <Tooltip
                                        title={LevelItem.description || ""}
                                        placement="right"
                                        enterDelay={1000}
                                        enterNextDelay={1000}
                                    >
                                        <span>{LevelItem.name}</span>
                                    </Tooltip>
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText id="contractLevel_helper">select the contracts to which this will attach (blank
                            means all)</FormHelperText>
                    </FormControl>
                    <br/>
                    <br/>
                    <FormControl variant="standard" sx={{m: 1, minWidth: 300}}>
                        <Tooltip enterDelay={1000}  enterNextDelay={1000}
                                 title={"Enter the folder into which this will go when generating new contracts."}>
                            <InputLabel htmlFor="destinationFolder">Destintation Folder</InputLabel>
                        </Tooltip>
                        <Select
                            {...register('destinationFolder', {required: true})}
                            labelId="demo-simple-select-filled-destinationFolder"
                            id="destinationFolder"
                            label="Destination Folder"
                            sx={{width: 300}}
                            onChange={handleFolderChange}
                            value={useSelector((state) => state.contractDataPointSlc.value.destinationFolder)}
                        >
                            {FolderDropdown.map((FolderItem) => (
                                <MenuItem
                                    key={FolderItem.id}
                                    value={FolderItem.name}
                                >
                                    <Tooltip
                                        title={FolderItem.description || ""}
                                        placement="right"
                                        enterDelay={1000}
                                        enterNextDelay={1000}
                                    >
                                        <span>{FolderItem.name}</span>
                                    </Tooltip>
                                </MenuItem>

                                )
                            )}
                        </Select>
                        <FormHelperText id="destinationFolder_helper">select the folder into which this will go on new
                            contracts</FormHelperText>
                    </FormControl>
                    <br/>
                    <br/>
                    <br/>
<Stack direction="row" spacing={12}>
    <Box>
                    <InputLabel htmlFor="versionInd">Version?</InputLabel>
                    {/*<Tooltip  enterDelay={1000}  title={"Should it generate a new version each time it is run (keeping the existing data as an old version?"}>*/}
                    <Checkbox
                        checked={versionFlag}
                        onClick={() => setVersionFlag(!versionFlag)}
                        {...register('versionInd', {required: false})}
                        id="versionInd" name="versionInd" label="versionInd" aria-describedby="versionInd_entry"
                        // defaultValue=        {useSelector((state) => state.contractDataPointSlc.value.versionInd)}
                        defaultValue={true}
                        sx={{width: 120}}/>
                    {/*</Tooltip>*/}
                    <FormHelperText id="versionInd_helper">Should new versions of this data point</FormHelperText>
                    <FormHelperText id="versionInd_helper2">be made each time the logic is runs?</FormHelperText>
    </Box>
    <Box>
        <InputLabel htmlFor="cycleInd">Cycle?</InputLabel>
    {/*<Tooltip  enterDelay={1000}  title={"Should it generate a new version each time it is run (keeping the existing data as an old version?"}>*/}
    <Checkbox
        checked={cycleFlag}
        onClick={() => setCycleFlag(!cycleFlag)}
        {...register('cycleInd', {required: false})}
        id="cycleInd" name="cycleInd" label="cycleInd" aria-describedby="cycleInd_entry"
        // defaultValue=        {useSelector((state) => state.contractDataPointSlc.value.versionInd)}
        defaultValue={false}
        sx={{width: 120}}/>
    {/*</Tooltip>*/}
    <FormHelperText id="cycleInd_helper">Should this data point cycle</FormHelperText>
    <FormHelperText id="cycleInd_helper2">as part of the calc logic?</FormHelperText>
    </Box>
    </Stack>
                    <br/>
                    <br/>
                    <Button
                        type="submit"
                    >Submit</Button>
                    <Button onClick={() => closeContractDataPointDrawer()}>Cancel</Button>
                    <HiddenFields/>
                </Box>
            </form>
        );}

    // ****************** END FORM ****************************


    // ****************** BEGIN HIDDEN FIELDS ****************************

    function HiddenFields() {
        return (
            <div>
                <Input style={{ visibility: "hidden" }}
                       {...register('versionNumber', { required: false })}
                       id="versionNumber" name="versionNumber"  label="versionNumber" aria-describedby="versionNumber"
                       defaultValue=        {useSelector((state) => state.contractDataPointSlc.value.versionNumber)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('status', { required: false })}
                       id="status" name="status"  label="status" aria-describedby="status_entry"
                       defaultValue=        {useSelector((state) => state.contractDataPointSlc.value.status)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('createdBy', { required: false })}
                       id="createdBy" name="createdBy"  label="createdBy" aria-describedby="createdBy_entry"
                       defaultValue=        {useSelector((state) => state.contractDataPointSlc.value.createdBy)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('lastModifiedBy', { required: false })}
                       id="lastModifiedBy" name="lastModifiedBy"  label="lastModifiedBy" aria-describedby="lastModifiedBy_entry"
                       defaultValue=        {useSelector((state) => state.contractDataPointSlc.value.lastModifiedBy)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('mockExpression', { required: false })}
                       id="mockExpression" name="mockExpression"  label="mockExpression" aria-describedby="mockExpression_entry"
                       defaultValue=        {useSelector((state) => state.contractDataPointSlc.value.mockExpression)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('mockExpressionTranslation', { required: false })}
                       id="mockExpressionTranslation" name="mockExpressionTranslation"  label="mockExpressionTranslation" aria-describedby="mockExpressionTranslation_entry"
                       defaultValue=        {useSelector((state) => state.contractDataPointSlc.value.mockExpressionTranslation)}
                />
                <Input style={{ visibility: "hidden" }}
                       {...register('partitionKey', { required: false })}
                       id="partitionKey" name="partitionKey"  label="partitionKey" aria-describedby="partitionKey"
                       value= "Master"
                />
            </div>
        )}

    // ****************** END HIDDEN FIELDS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                anchor='right'
                open={selectorCdpDrawerState}
                onClose={closeContractDataPointDrawer}
            >
                {contractDataPointForm()}

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
